import { IExchangeRateItem } from "interfaces";
import { get } from "lodash";
import { CURRENCY_LIST } from "utills/constants";
import { formatNumber } from "utills/helpers";

interface ExchangeRateTableProps {
  data: IExchangeRateItem;
}

export const ExchangeRateTable = ({ data }: ExchangeRateTableProps) => {
  return (
    <div className="flow-root">
      <div className="overflow-x-auto">
        <div className="relative inline-block min-w-full align-middle">
          <table className="min-w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
            <thead>
              <tr>
                <th
                  scope="col"
                  className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
                >
                  No
                </th>
                <th scope="col" className="th">
                  Currency name
                </th>
                <th scope="col" className="th">
                  Alphabetic Code
                </th>
                <th scope="col" className="th">
                  Exchange rate
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {Object.keys(data?.rates ?? {}).map((key: string, index: number) => (
                <tr key={index}>
                  <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                   {index + 1}
                  </td>
                  <td className="td">{CURRENCY_LIST.find(currency => currency.code === key)?.name ?? key}</td>
                  <td className="td">{key}</td>
                  <td className="td">
                    <p className="text-sm leading-6 w-fit" data-tooltip-id="tooltip" data-tooltip-content={get(data.rates, key, 0).toString()}>
                      {formatNumber(Math.round(get(data?.rates, key, 0)))}
                    </p>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}